/*
 * @Author: Chao Yang
 * @Date: 2021-11-11 07:53:53
 * @LastEditor: Chao Yang
 * @LastEditTime: 2021-11-11 07:55:09
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BrandProxy } from 'src/app/domain/proxy/brand/index';

@Injectable()
export class BrandService {
  constructor(private brandProxy: BrandProxy) { }

  get(
  ): Observable<any> {
    return this.brandProxy.get();
  }

  switch(brand: string): Observable<any> {
    return this.brandProxy.switch(brand);
  }
}
